'use client';
import { CssBaseline } from '@mui/material';
import {
  ThemeProvider as MuiThemeProvider,
  ThemeOptions,
  createTheme,
  responsiveFontSizes,
} from '@mui/material/styles';
import { ColorModeProvider } from '@treyd-io/treyd-ui/providers/colorModeProvider';
import darkThemeOptions from '@treyd-io/treyd-ui/themes/darkOptions.theme';
import lightThemeOptions from '@treyd-io/treyd-ui/themes/lightOptions.theme';

import localFont from 'next/font/local';
import { ReactNode, useMemo } from 'react';

interface ThemeProviderProps {
  children: ReactNode;
}

const TWKLausanne = localFont({
  src: [
    {
      path: '../../ui/fonts/Lausanne/TWKLausanne-300.ttf',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../../ui/fonts/Lausanne/TWKLausanne-400.ttf',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../ui/fonts/Lausanne/TWKLausanne-550.ttf',
      weight: '550',
      style: 'bold',
    },
  ],
  display: 'swap',
});

const extendTheme = (themeOptions: ThemeOptions) =>
  createTheme({
    ...themeOptions,
    typography: {
      ...themeOptions.typography,
      fontFamily: `${TWKLausanne.style.fontFamily}, "sans-serif"`,
    },
  });

const THEMES = {
  light: extendTheme(lightThemeOptions),
  dark: extendTheme(darkThemeOptions),
};

const ThemeProviderWrapper = (props: ThemeProviderProps) => {
  //TODO: Implement color mode after adding dark mode
  // const { colorMode } = useContext(ColorModeContext);
  const selectedTheme = useMemo(() => THEMES['light'], []);
  const theme = responsiveFontSizes(selectedTheme);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {props.children}
    </MuiThemeProvider>
  );
};

export const ThemeProvider = (props: ThemeProviderProps) => {
  return (
    <ColorModeProvider>
      <ThemeProviderWrapper {...props} />
    </ColorModeProvider>
  );
};
